/**
 * Tipos de cálculo soportados por el catálogo de claves de amortización.
 * Los valores son los que exige el CHECK de depreciation_methods.method_type en
 * el backend — comprobado empíricamente: 'linear'/'degressive' lo rechaza en
 * silencio (INSERT sin efecto, sin error visible).
 */
export type DepreciationMethodType = 'straight_line' | 'declining_balance';

export const DEPRECIATION_METHOD_TYPE_LABELS: Record<DepreciationMethodType, string> = {
  straight_line: 'Lineal',
  declining_balance: 'Degresivo'
};

export interface DepreciationMethod {
  id: string;
  code: string;
  name: string;
  methodType: DepreciationMethodType;
  annualRatePct: number;
  status: 'active' | 'inactive';
}

export interface DepreciationMethodPayload {
  code: string;
  name: string;
  methodType: DepreciationMethodType;
  annualRatePct: number;
  status?: 'active' | 'inactive';
}
